import { useParams } from "react-router";
import { apiFetch } from "@/service/api";
import { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    AuraSurveyDashboard: any;
  }
}

export default function SurveyDashboard() {
  const { id } = useParams();
  const containerRef = useRef<HTMLDivElement>(null);
  const dashboardRef = useRef<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    const loadCss = (href: string) => {
      if (document.querySelector(`link[href="${href}"]`)) return;
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    };

    const loadJs = (src: string) =>
      new Promise<void>((resolve, reject) => {
        if (window.AuraSurveyDashboard) return resolve();
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error(`No se pudo cargar ${src}. Verifica que esté en /public`));
        document.body.appendChild(s);
      });

    const init = async () => {
      try {
        setLoading(true);
        loadCss("/libs/aura-survey/css/aura-survey-dashboard.css");
        await loadJs("/libs/aura-survey/js/aura-survey-dashboard.js");

        const res = await apiFetch(`survey-response/survey/${id}`);
        if (!res.ok) throw new Error(`Error ${res.status}`);
        const data = await res.json();

        console.log("API:", data);

        // SOPORTA LOS 2 FORMATOS: tu formato actual de array y el nuevo {schema, responses}
        let schema: any;
        let responses: any[];

        if (data.schema && data.responses) {
          // nuevo formato del service que te puse arriba
          schema = data.schema;
          responses = data.responses;
        } else if (Array.isArray(data)) {
          // formato actual tuyo
          schema = data[0]?.survey?.survey;
          responses = data.map((d: any) => d.response?? d);
        } else {
          throw new Error("Formato de API no reconocido");
        }

        if (!schema?.pages) throw new Error("Schema sin pages");
        if (!containerRef.current) throw new Error("Container no montado");

        dashboardRef.current?.destroy?.();
        containerRef.current.innerHTML = "";

        dashboardRef.current = new window.AuraSurveyDashboard(
          "#survey-dashboard-container",
          { schema, responses }
        );
      } catch (e: any) {
        console.error(e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    init();
    return () => dashboardRef.current?.destroy?.();
  }, [id]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Dashboard - Encuesta {id}</h1>
      {loading && <div className="p-4">Cargando dashboard...</div>}
      {error && <div className="p-4 text-red-500">{error}</div>}
      <div id="survey-dashboard-container" ref={containerRef} />
    </div>
  );
}